"use strict";
/// <reference path="irep.js"/>

IREP.eldoradopromo = (function () {
    var loader = $("#loader");
    var step1 = $("#step1");
    var step2 = $("#step2");
    var step3 = $("#step3");
    var step4 = $("#step4");

    var init = function (options) {
        GetEmployeeCode();
    };

    var GetEmployeeCode = function () {
        IREP.callApi("eldoradopromo/getcode", "GET")
        .done(function (data) {
            if (isEmpty(data) || data.employeeCode === "") {
                $(".employeeCode").text("0");
                CheckStep2();
            } else {
                $(".employeeCode").text(data.employeeCode);
                CheckStep2();
            }
        });
    };

    var CheckStep2 = function () {
        var trainings = ['201305cha-PCBasicsTalk', '201306cha-CPUFamily', '201310html-GreatTablet', '201309html-HolidayPreview', '201308html-ThinLaptops'];
        IREP.callApi("eldoradopromo/hascompletedtrainings", "POST", { Activities: trainings, PassRequired: true }).done(function (data) {
            if (data.hasCompletedTrainings) {
                CheckStep3();
            } else {
                loader.fadeOut(200);
                step2.fadeIn(200);
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            IREP.displayError(jqXHR, textStatus, errorThrown);
        });
    };

    var CheckStep3 = function () {
                loader.fadeOut(200);
                step3.fadeIn(200);
    };

    var isEmpty = function (obj) {
        return Object.keys(obj).length === 0;
    };
    return {
        init: init
    };
})();